import {
  BrowserModule,
  Title,
} from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppCommonModule } from './common/common.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './modules/material.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { CoreModule } from './core/core.module';
import { RouteUtilService } from './shared/utils/route-util.service';
import { HeaderComponent } from './common/header/header.component';
import { MainComponent } from './common/main/main.component';
import { NavigationComponent } from './common/navigation/navigation.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { SharedModule } from './shared/modules/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { NgSelectModule } from '@ng-select/ng-select';
import { DatepickerComponent } from './shared/directives/datepicker/datepicker.component';
import { CommonModule, DatePipe } from '@angular/common';
import { TimepickerComponent } from './shared/directives/timepicker/timepicker.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { NgProgressModule } from "ngx-progressbar";
import { NgProgressHttpModule } from "ngx-progressbar/http";
import { MatTooltipModule } from '@angular/material/tooltip';
import { AccessDeniedComponent } from './modules/user-permission/access-denied/access-denied.component';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { NgIdleModule } from '@ng-idle/core';
import {AUTH_CONFIG,NphsCommNucbotWidgetModule, NUCBOT_CONFIG, PROJECT_ID, SESSION_ID, WindowRef} from "@nphs-comm/nphs-comm-nucbot-widget";
import { Environment } from './core/environment/environment';



@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        NavigationComponent,
        MainComponent,
        DatepickerComponent,
        AccessDeniedComponent,

        // TimepickerComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        AppCommonModule,
        CoreModule.forRoot(),
        MaterialModule,
        FontAwesomeModule,
        CoreModule,
        ToastrModule.forRoot(),
        MatAutocompleteModule,
        SharedModule,
        MatInputModule,
        MatSelectModule,
        MatCardModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        NgSelectModule,
        CommonModule,
        NgProgressModule.withConfig({
            color: "#0b50cede"
        }),
        NgProgressHttpModule,
        MatTooltipModule,
        NgIdleModule.forRoot()], 
        providers: [
            { provide: 'windowObject', useValue: window },
            { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
            {
                provide: MatDialogRef,
                useValue: {}
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: TokenInterceptor,
                multi: true,
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: ErrorInterceptor,
                multi: true
            },
            Title,           
            ToastrService,
            RouteUtilService,
            NphsCommNucbotWidgetModule,
            DatePipe,
            provideHttpClient(withInterceptorsFromDi()),   
            //  REQUIRED for nucbot widget (AUTH_CONFIG)
            {
                provide: AUTH_CONFIG,
                useValue: {
                    token: '', // will be set later dynamically
                    api: {
                    key: Environment.getInstance().appConfig.apiKey, //'mAaAzldozhT2H47AVg6gAke8M4lUhsAO',
                    dialogFlowUrl: Environment.getInstance().apiConfig.nucbotDialog  //'https://api.dev.cardinalhealth.com/nphs/nuctrac-bot/v1/api/dialogflow'
                    }
                }
            },      
            //REQUIRED for dfService.getProperties() in nucbot  
            {                
                provide: NUCBOT_CONFIG,
                    useValue: {
                    nucbotDialogflow:'https://api.dev.cardinalhealth.com/nphs/nuctrac-bot/v1/api/dialogflow',
                    nucbotToken:'https://api.dev.cardinalhealth.com/nphs/nuctrac-config/v1',
                    apikey: 'mAaAzldozhT2H47AVg6gAke8M4lUhSAO',
                    nucbotProjectId:'nphs-comm-np-cah'                   
                }                            
            },
            {
                provide: WindowRef, useValue: {nativeWindow: window } 
            },
            {
                provide:PROJECT_ID, useValue:Environment.getInstance().apiConfig.nucbotProjectID           
            },
            {
                provide:SESSION_ID, useValue:'default-session-id'           
            }      

       ]    
})
export class AppModule { }
